const rankingItems = [
  {
    rank: 1,
    title: '破晓行动',
    type: '动作 / 犯罪',
    score: '9.2',
    hot: '本周最热',
    desc: '暑期档动作巨制，硬汉对决引爆大银幕',
    trend: 'up',
  },
  {
    rank: 2,
    title: '笑到停不下来',
    type: '喜剧',
    score: '8.9',
    hot: '口碑飙升',
    desc: '沈腾马丽再度联手，爆笑喜剧新标杆',
    trend: 'up',
  },
  {
    rank: 3,
    title: '星际穿越',
    type: '科幻 / 冒险',
    score: '9.4',
    hot: '经典重温',
    desc: '诺兰科幻神作，穿越时空的父子情深',
    trend: 'same',
  },
  {
    rank: 4,
    title: '功夫',
    type: '动作 / 喜剧',
    score: '8.8',
    hot: '周星驰精选',
    desc: '周星驰经典之作，小人物的英雄梦想',
    trend: 'up',
  },
  {
    rank: 5,
    title: '你的名字',
    type: '动画 / 爱情',
    score: '8.7',
    hot: '动画推荐',
    desc: '新海诚纯爱经典，跨越时空的相遇',
    trend: 'same',
  },
  {
    rank: 6,
    title: '消失的爱人',
    type: '悬疑 / 惊悚',
    score: '8.6',
    hot: '烧脑推荐',
    desc: '大卫·芬奇悬疑经典，婚姻的黑暗面',
    trend: 'down',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            热映榜单
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            小草影院最受欢迎的影片排行，看看大家都在看什么
          </p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className="group flex items-center gap-4 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                {item.rank <= 3 ? (
                  <span
                    className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold text-white ${
                      item.rank === 1
                        ? 'bg-accent-500'
                        : item.rank === 2
                          ? 'bg-secondary-500'
                          : 'bg-primary-500/70'
                    }`}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-base font-bold text-foreground-400">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="text-sm font-semibold text-foreground-900 font-heading whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.type}</span>
                </div>
                <p className="text-xs text-foreground-600">{item.desc}</p>
              </div>

              <div className="flex-shrink-0 flex items-center gap-3">
                <span className="text-xs text-foreground-500 bg-background-100 px-2 py-1 rounded whitespace-nowrap">
                  {item.hot}
                </span>
                <div className="text-right">
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    <span className="text-sm font-bold text-foreground-900">{item.score}</span>
                  </div>
                  <span className="text-xs text-foreground-500">
                    {item.trend === 'up' ? '↑' : item.trend === 'down' ? '↓' : '–'}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}